import React, { useState, useContext } from "react";
import $ from 'jquery';
import Toastr from 'toastr';
import SessionManager from '../../routes/SessionManager';
import no_image from './../../assets/img/no-image.png';
import { Context } from '../../views/app';

function FavoriteZones() {

  let appContex = useContext(Context);
  let user = appContex.user;
  let site_selected_id = user.site_selected.site_id;
  let favZones = user.fav_zones;
  const [fav_zones, setFavZones] = useState(favZones && favZones[site_selected_id] ? favZones[site_selected_id] : []);
  const [save_btn_enabled, setSaveBtnEnabled] = useState(false);

  const storeFavoriteZones = (zone) => {
    var locations_opted = [...fav_zones];
    let currLoc = zone.location_id + '';

    if (locations_opted && locations_opted.indexOf(currLoc) === -1)
      locations_opted.push(currLoc);
    else {
      locations_opted = locations_opted.filter(loc => loc !== currLoc);
    }
    // console.log('locations_opted', locations_opted)
    let userCopy = JSON.parse(JSON.stringify(user));
    let user_location_opted = (userCopy.fav_zones && user.fav_zones[site_selected_id]) ? userCopy.fav_zones[site_selected_id] : [];
    let isModified = JSON.stringify(user_location_opted) !== JSON.stringify(locations_opted);
    setFavZones(locations_opted);
    setSaveBtnEnabled(isModified);
  }

  const saveFavouriteZones = (event) => {
    var saveBtn = event.target;
    saveBtn.innerHTML = 'Saving ...';
    saveBtn.disabled = true;

    let favouriteZones = user.fav_zones ? { ...user.fav_zones } : {};
    favouriteZones[site_selected_id] = [...fav_zones];
    console.log(favouriteZones)
    let zones = user.zones.map((z) => z.location_id);
    var favourite = [...favouriteZones[site_selected_id]];
    for (var i = 0; i < favourite.length; i++) {
      if (!zones.includes(favourite[i])) {
        var index = favouriteZones[site_selected_id].indexOf(favourite[i]);
        favouriteZones[site_selected_id].splice(index, 1);
      }
    }

    for (let i in favouriteZones) {
      if (i < 100)
        delete favouriteZones[i];
    }

    var data = {
      form_input: {
        fav_zones: favouriteZones,
        user_login: user.user_login,
        user_token: user.user_token
      },
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token
    }

    $.ajax({
      url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/user/modify',
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(data)
    }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          var sessionMgr = new SessionManager();
          let userCopy = JSON.parse(JSON.stringify(user));
          userCopy.fav_zones = res.data.Attributes.fav_zones;
          sessionMgr.storeCookie('user', userCopy);
          console.log("sess:", userCopy);

          setFavZones(userCopy.fav_zones ? userCopy.fav_zones[site_selected_id] : []);
          setSaveBtnEnabled(false);

          Toastr.success('Changes saved successfully !');
          saveBtn.innerHTML = 'Save';
          saveBtn.disabled = false;

          $('[data-dismiss="modal"]').trigger('click');
          if (user.fav_zones[site_selected_id].indexOf(zones.location_id + "") === -1)
            window.location.reload();
        }
      }
    );
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6">
          <label className="text-primary text-bold">Choose Favorite Zones:</label>
        </div>
        <div className="col-md-6 text-right">
          <button type="button" onClick={saveFavouriteZones} className="btn btn-primary btn-sm" disabled={!save_btn_enabled}>Save</button>
        </div>
      </div>

      <div className="row">
        {user.zones.map((zone, i) => (
          <div key={"location" + i} className="col-3 col-md-2 p-1 p-md-2">
            <div key={zone.location_id} className="cursor-pointer p-0" onClick={() => storeFavoriteZones(zone)}>
              <img onError={(e) => e.target.src = no_image} className="img-fluid border-rounded-t" src={zone.image} alt={zone.location_name} />
              <div className="bg-light p-1 border-rounded-b">
                <i className={fav_zones.indexOf(zone.location_id + "") !== -1 ? "fa text-primary fa-lg fa-checkbox fa-check-square mr-1" : "far text-primary fa-lg fa-checkbox fa-square mr-1"}></i>
                <span data-toggle="tooltip" data-placement="bottom" title={zone.location_name.length > 12 ? zone.location_name : ''}>{zone.location_name.length > 12 ? zone.location_name.substring(0, 12) + '..' : zone.location_name}</span>
              </div>
            </div>
          </div>
        ))}
      </div>


      <br /><br />
      <small><b>Note:</b> Zones chosen here as favorites are only shown/applicable in Timelapse screens. If none are selected, by default all the zones are displayed.</small>

    </React.Fragment>
  );
}

export default FavoriteZones;
